// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.line[data-v-554552e3]{\r\n\tmargin-top:0;\r\n\tmargin-bottom:0;\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t    -ms-user-select: none;\r\n\t        user-select: none;\n}\n*[data-v-554552e3].line:empty:before {\r\n\tcontent: ' ';\r\n\twhite-space: pre;\r\n\tdisplay:inline-block;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
